import { createSelector } from 'reselect'
import { AppState } from '../store/types/Store';
import { ModalSize } from '../types';
import { getViewIndex } from './commonSelectors';

export const getModalData = (state: AppState) => state.modal;

export const getModalShow = createSelector([
  getModalData,
  getViewIndex
], (modalData, index) => Boolean(modalData.modalsShown[index]));

export const getModalType = createSelector([
  getModalData
], (modalData) => modalData.meta?.type);

export const getModalMode = createSelector([
  getModalData
], (modalData) => modalData.meta?.mode);

export const getModalSize = createSelector([
  getModalData
], (modalData) => modalData.meta?.size ?? ModalSize.S);

export const getModalMetaData = createSelector([
  getModalData
], (modalData) => modalData.meta);

export const getModalActivity = createSelector([
  getModalData
], (modalData) => modalData.meta?.activity);
